import type { ReactNode } from 'react';
import { RAG_STEPS, RAG_STEP_COUNT } from './steps';

interface Props {
  step: number;
  /** Controls shown on the right of the heading (e.g. a preview toggle). */
  aside?: ReactNode;
}

/** Step card heading: "Step n of 6" eyebrow, the step title and its one-line description. */
export default function RagStepHeader({ step, aside }: Props) {
  const def = RAG_STEPS[step - 1];
  return (
    <div className="mb-[22px] flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="mb-1.5 font-mono text-[11px] font-semibold uppercase tracking-[0.1em] text-muted">Step {step} of {RAG_STEP_COUNT}</p>
        <h2 className="font-display text-2xl font-bold tracking-[-0.01em] text-ink">{def?.label}</h2>
        <p className="mt-1.5 text-sm text-muted">{def?.description}</p>
      </div>
      {aside}
    </div>
  );
}
